import React,{ useCallback, useEffect, useState } from "react";
import { Divider } from "antd";
import { DenominationTypes } from "../../constants/DenominationTypes";
import OrderInformationHeader from "./OrderInformationHeader";
import OrderInformationRow from "./OrderInformationRow";
import { calculateOrderRowAmount, getTotalOrderFee, voidBNOrder } from "./OrderService";
import OrderInformationFooter from "./OrderInformationFooter";
import AlertBox from "../shared/AlertBox";
import LoadingBox from "../shared/LoadingBox";


export function OrderInformationScreen({customerName, customerID, buyCcy, crossR, objOrder, updateOrder, lockedSide, currenciesList, settlementCurrenciesList, deliveryMethodList,changeScreen, updateBuyCurrencyValue, editCostRate, backToSearchScreen}) {

    const [buyCurrency, setBuyCurrency] = useState(localStorage.getItem('BaseCurrency'));
    const baseCurrency = localStorage.getItem('BaseCurrency');
    const [crossRate, setCrossRate] = useState(0);
    const [buyScale, setBuyScale] = useState(2);
    const today = new Date();
    const hours = String(today.getHours()).padStart(2, '0');
    const minutes = String(today.getMinutes()).padStart(2, '0');
    const [deliveryDate, setDeliveryDate] = useState(today);
    const [deliveryTime, setDeliveryTime] = useState(`${hours}:${minutes}`);
    const [deliveryCustomerID, setDeliveryCustomerID] = useState(0);
    const [deliveryText, setDeliveryText] = useState('');
    const [deliveryFee, setDeliveryFee] = useState(0);
    const [deliveryContactName, setDeliveryContactName] = useState('');
    const [totalBuyAmount, setTotalBuyAmount] = useState(0);
    const [totalDenominationFees, setTotalDenominationFees] = useState(0);
    const [totalProfit, setTotalProfit] = useState(0);
    const [deliveryMethod, setDeliveryMethod] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showVoidConfirmation, setShowVoidConfirmation] = useState(false);
    const [orderRows, setOrderRows] = useState([{
        key:1,
        CurrencyID: '',
        CurrencyName:'',
        CurrencyScale: 2,
        Denominations: [],
        Amount: 0,
        Rate: 0,
        BuyAmount: 0,
        Fee:0,
        DenominationType: DenominationTypes.notes,
        Profit:0,
        CostRate: 0,
        RatePrecision:8,
        MixedNotes:false,
        validations:{
            CurrencyID: true,
            Denominations: true,
            Amount: true,
            Rate: true,
            BuyAmount: true
        }        
    }]);
   
    const [validationsHeader, setValidationsHeader] = useState(
      {
          DeliveryCustomerID: true,
          DeliveryDate: true,
          DeliveryTime: true,
          DeliveryMethod: true,
          BuyCurrency: true,
          CrossRate: true
        }
      )

    const getNextDay = () =>{
      const startDate = new Date();
      startDate.setHours(0, 0, 0, 0);
      let validNextDate = false;

      while(!validNextDate)
      {
        startDate.setDate(startDate.getDate() + 1);

        if(startDate.getDay() !== 0 && startDate.getDay()!== 6)
        {
          validNextDate = true;
        }
     }
      return new Date(startDate);
    }

     useEffect(()=>{
        
        const nextDay = getNextDay();
        const hours = '14';//String(today.getHours()).padStart(2, '0');
        const minutes = '00';//String(today.getMinutes()).padStart(2, '0');
      
        setDeliveryDate(nextDay);
        setDeliveryTime(`${hours}:${minutes}`);
      },[])

      useEffect(()=>{  
        setBuyCurrency(buyCcy);
        setCrossRate(crossR);
      },[buyCcy, crossR])
  
    useEffect(()=> {
      if(objOrder && objOrder.OrderRows && objOrder.OrderRows.length>0)
      {
        setOrderRows(objOrder.OrderRows);     
      }
      if(objOrder.BuyCurrency)
      {
        setBuyCurrency(objOrder.BuyCurrency);
      }
      if(objOrder.CrossRate)
      {
        setCrossRate(objOrder.CrossRate);
      }
      if(objOrder.DeliveryDate && objOrder.DeliveryDate !== '' && objOrder.DeliveryTime && objOrder.DeliveryTime !== '')
      {
        setDeliveryDate(objOrder.DeliveryDate);
        setDeliveryTime(objOrder.DeliveryTime);
      }
      if(objOrder.DeliveryMethod && objOrder.DeliveryMethod !== '')      {
        setDeliveryMethod(objOrder.DeliveryMethod);

        if(objOrder.DeliveryCustomerID > 0)
        {
          setDeliveryCustomerID(objOrder.DeliveryCustomerID);      
          setDeliveryText(objOrder.DeliveryText);
          setDeliveryFee(objOrder.DeliveryFee);
          setDeliveryContactName(objOrder.DeliveryContactName); 
        }         
      }
    },[objOrder])

    const getRows=()=>{
        const rows = [];
        if(orderRows)
        {
            orderRows.forEach((o, index) =>{
                rows.push(<OrderInformationRow customerID={customerID} rowObject={o} rowID={o.key} lockedSide={lockedSide} buyCurrency={buyCurrency} currenciesList={currenciesList} 
                    buyScale={buyScale} onDeleteRow={onDeleteRow} onUpdateFieldRow={onUpdateFieldRow} validations={o.validations} onUpdateRowAmounts={onUpdateRowAmounts}
                    deliveryDate={deliveryDate} autoFocus={(orderRows.length> 1 && index === orderRows.length -1)} openAlert={openAlert} editCostRate={editCostRate}/>)
            })
        }
        return rows;
    }

    const currencyAlreadyExists = (currencyID, key) => {
      const existCCy = orderRows.find(o => o.CurrencyID === currencyID && o.key !== key);
      if(existCCy)
        return false
      return true;
    }

    const rowIsValid = (lastOrder) =>{
      
      const prev = lastOrder.validations;
      const demoninationsAmount = calculateOrderRowAmount(lastOrder.Denominations, lastOrder.DenominationType);

      const validations = {
        ...prev,
        Amount: lastOrder.Amount > 0,
        BuyAmount: lastOrder.BuyAmount > 0,
        CurrencyID: !!lastOrder.CurrencyID && currencyAlreadyExists(lastOrder.CurrencyID, lastOrder.key),
        Denominations: lastOrder.MixedNotes || lastOrder.Amount === demoninationsAmount,
        Rate: lastOrder.Rate > 0
      };

      return validations;
    }

    const onAddClick =() =>{
        const order = {};
        order.key = orderRows.length > 0 ? (orderRows[orderRows.length - 1].key + 1) : 1;
        order.BuyAmount = 0;
        order.Fee = 0;
        order.DenominationType = DenominationTypes.notes;
        order.Denominations = [];
        order.validations={
            CurrencyID: true,
            Denominations: true,
            Amount: true,
            Rate: true,
            BuyAmount: true
        }        
        const orders = [...orderRows];
        if(orders.length > 0)
        {
          const lastOrder = orders[orders.length - 1];
          const validations = rowIsValid(lastOrder)
          orders[orders.length - 1] = {...lastOrder,validations};
            
          if(Object.values(validations).every(Boolean))
          {
            order.validations = validations;
            orders.push(order);
          }   
          else
          {
            const duplicateCcy = orders.find(c => !c.validations.CurrencyID && c.CurrencyID !== '')
            if(duplicateCcy)
            {
              setAlertTitle('Error');
              setAlertMessage(`${duplicateCcy.CurrencyID} currency has already been used in this order.`);       
              setShowAlert(true);
            }
            else
            {
              setAlertTitle('Error');
              setAlertMessage('You missed some fields.');       
              setShowAlert(true);
            } 
          }               
        }
        else
        {
          orders.push(order);
        }
        setOrderRows(orders);
    }

    const onDeleteRow = (key) => {
        let rows = [...orderRows];    
        rows = rows.filter((d) => d.key !== key);
        setOrderRows(rows);
    };
    
    const onUpdateFieldRow = (key, Field, value) =>{
        setOrderRows(prev => {
            const rows = [...prev];
            const index = rows.findIndex((r) => r.key === key );
            if(index > -1)
            {
                rows[index] = { ...rows[index], [Field]: value };
            }
            return rows;
        });
    }

    const onUpdateRowAmounts = (key, amount, rate, buyAmount, fee, denominations, profit, costRate, ratePrecision, rateTerms) =>{
        setOrderRows(prev => {
            const rows = [...prev];
            const index = rows.findIndex((r) => r.key === key );
            if(index > -1)
            {
                rows[index] = { ...rows[index], Amount: amount, Rate: rate, BuyAmount:buyAmount, Fee: fee, Denominations: [...denominations], Profit:profit, CostRate: costRate, RatePrecision: ratePrecision, RateTerms: rateTerms };
            }
            return rows;
        });
    }

  const updateTotalValues = useCallback((totalBuyAmount, totalDenominationFees, totalProfit) =>{
    setTotalBuyAmount(totalBuyAmount);
    setTotalDenominationFees(totalDenominationFees);
    setTotalProfit(totalProfit);
  }, []);

  const validHeader= ()=>{
     const prev = validationsHeader;
     const today = new Date();
     const [h, m] = deliveryTime.split(':');
    const selectedDateTime = new Date(deliveryDate).setHours(Number(h), Number(m),0,0);
    const showCompanyAddress = (lockedSide.toLowerCase() === 'buy' && deliveryMethod.toLowerCase().includes('sends currency'));

    const validations = {
        ...prev,
        DeliveryCustomerID : deliveryCustomerID > 0,
        DeliveryDate: showCompanyAddress || selectedDateTime >= today,
        DeliveryTime: showCompanyAddress || selectedDateTime >= today,
        DeliveryMethod: (deliveryMethod !== null && deliveryMethod !== undefined && deliveryMethod !== ''),
        BuyCurrency: (buyCurrency !== null && buyCurrency !== undefined && buyCurrency !== ''),
        CrossRate: (buyCurrency !== baseCurrency && crossRate > 0) || buyCurrency === baseCurrency
      };

    setValidationsHeader(validations);

    return Object.values(validations).every(Boolean)
  }

  const onNextClick = async() =>{

    const orders = [...orderRows];
    if(orders.length > 0)
    {

    const orderRowsValidated = orderRows.map(o => ({
        ...o,
        validations: rowIsValid(o)
      }));
      setOrderRows(orderRowsValidated);

      const allValid = orderRowsValidated.every(o =>
        Object.values(o.validations).every(Boolean)
      );

      const headerIsValid = validHeader();
        
      if(allValid && headerIsValid)
      {
        const responseTotalOrderFee = await getTotalOrderFee(customerID, totalBuyAmount, lockedSide);
        const totalOrderFee = (responseTotalOrderFee.Success)?responseTotalOrderFee.TotalOrderFee:0;

        objOrder.DeliveryDate = deliveryDate;
        objOrder.DeliveryTime = deliveryTime;
        objOrder.DeliveryCustomerID = deliveryCustomerID;
        objOrder.DeliveryText = deliveryText;
        objOrder.DeliveryContactName = deliveryContactName;
        objOrder.OrderRows = orderRowsValidated;
        objOrder.TotalOrder = totalBuyAmount;
        objOrder.TotalProfit = totalProfit;
        objOrder.DenominationFee = totalDenominationFees;
        objOrder.DeliveryFee = deliveryFee;
        objOrder.OrderFee = totalOrderFee;
        objOrder.DeliveryMethod = deliveryMethod;
        objOrder.BuyCurrency = buyCurrency;
        objOrder.CrossRate = crossRate;

        updateOrder(objOrder);
        changeScreen();
        console.log(objOrder);
      }   
      else
      {
        const duplicateCcy = orderRowsValidated.find(c => !c.validations.CurrencyID && c.CurrencyID !== '')
        if(duplicateCcy)
            {
              setAlertTitle('Error');
              setAlertMessage(`${duplicateCcy.CurrencyID} currency has already been used in this order.`);       
              setShowAlert(true);
            }
            else
            {
              setAlertTitle('Error');
              setAlertMessage('You missed some fields.');       
              setShowAlert(true);
            } 
      }               
    }

  }

  const updateDeliveryTo = (value, label, fee, contactName) =>{
    if(value > 0)
    {
      setDeliveryCustomerID(value);
      setDeliveryText(label);
      setDeliveryFee(fee);
      setDeliveryContactName(contactName);
    }
  }

  const updateBuyCurrency = (currency, crossRate) =>{
    if(currency.value !== '')
    {
      setBuyCurrency(currency.value);
      setBuyScale(currency.NumberOfDecimals);
      setCrossRate(crossRate);

      updateBuyCurrencyValue(currency.value, crossRate);
    }
  }

  const getHeaders = () =>{
     return(
            <tr>
                <th key="1">Currency</th>
                <th key="2">Amount</th>
                {editCostRate &&
                <th key="6"> Cost Rate</th>}
                <th key="3">Rate</th>
                
                <th key="4">{`${buyCurrency} Value`}</th>
                {editCostRate &&
                <th key="7"> Profit</th>}
                <th key="5"></th>
            </tr>
        );
  }

  const closeAlert = () => {
        setShowAlert(false);
        setAlertTitle('');
        setAlertMessage('');
    };

  const openAlert = (title, message) => {
        setShowAlert(true);
        setAlertTitle(title);
        setAlertMessage(message);
    };


  const onTab = (e) => {

    if (e.key === 'Tab') {
      e.preventDefault();
      onAddClick();
    }
  }  

  const closeVoidConfirmation = () =>{
    setShowVoidConfirmation(false);
  }

  const yesVoidConfirmation = async() =>{
    setShowVoidConfirmation(false);
    setLoading(true);
    const responseSave = await voidBNOrder(objOrder.BNOrderNo);
    setLoading(false);    
    const message = [];
    message.push(responseSave.Message);    
    if(responseSave.Success)
    {
       if(backToSearchScreen)
       {
        backToSearchScreen();
       }
    }
  
    setAlertTitle(responseSave.Title);
    setAlertMessage(message);
    setShowAlert(true);
    
  }

  const onVoidClick = ()=>{
    setShowVoidConfirmation(true);
  }

  return (
    <div>

        <div>
                <OrderInformationHeader customerName={customerName} customerID={customerID} validations={validationsHeader} locationCustomerID={deliveryCustomerID} date={deliveryDate} time={deliveryTime} updateDeliveryDate={(date) => setDeliveryDate(date)}
                  updateDeliveryTime={(time) => setDeliveryTime(time)} updateDeliveryTo={updateDeliveryTo}
                  lockedSide={lockedSide} deliveryMethodList={deliveryMethodList} updateDeliveryMethod={(d) => setDeliveryMethod(d.value)}
                  deliveryMethodSelected={deliveryMethod} settlementCurrenciesList={settlementCurrenciesList} 
                  updateBuyCurrency={updateBuyCurrency} buyCurrencySelected={buyCurrency} crossR={crossRate}/>
        
            <table className="uk-table uk-table-hover uk-table-divider border-table">
                <thead>
                        {getHeaders()}
                </thead>
                <tbody>
                        {getRows()}
                </tbody>
            </table>
        
        </div>
        <div  align="right">
            <button id={'btn-order-add'} onKeyDown={onTab} key={'btn-order-add'} className="uk-button uk-button-green" onClick={onAddClick}>
                {'Add'}
            </button>
        </div>
        <Divider />
        <OrderInformationFooter orderRows={orderRows} buyScale={buyScale} updateTotalValues={updateTotalValues}/>
        <Divider />
        <div  align="right">
            {objOrder.BNOrderNo > 0 &&
            <button className="uk-button uk-button-green" onClick={onVoidClick}>
                {'Void'}
            </button>}
            <button className="uk-button uk-button-green" onClick={onNextClick}>
                {'Next'}
            </button>
        </div>
        <LoadingBox loading={loading}/>
        <AlertBox open={showAlert} onClose={closeAlert} title={alertTitle} message={alertMessage} type="Ok" okClick={closeAlert} />
        <AlertBox id="void-confirmation"
                            open={showVoidConfirmation}
                            title="Confirmation"
                            message="Are you sure you want to void this order?"
                            type="Yes/No"
                            onClose={closeVoidConfirmation}
                            yesClick={yesVoidConfirmation}
                            noClick={closeVoidConfirmation}/>
    </div>
  );
};

export default OrderInformationScreen